import { CALYPSO_MEDIUM, LORAX_LIGHT, OBSIDIAN, OLAF } from 'HubStyleTokens/colors';
import UIBanner from 'UIComponents/alert/UIBanner';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import styled from 'styled-components';
import SkeletonCircle from 'ui-addon-upgrades/_core/common/components/loading/SkeletonCircle';
import SkeletonText from 'ui-addon-upgrades/_core/common/components/loading/SkeletonText';
import SkeletonBox from '../../_core/common/components/loading/SkeletonBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "LoadingBanner__Container",
  componentId: "sc-2tumhi-0"
})(["display:flex;justify-content:center;align-items:center;padding:8px 16px;background:", ";"], LORAX_LIGHT);
const LoadingBanner = ({
  isUngatedUpgradeBannerRedesign2024,
  className,
  style = {}
}) => {
  if (isUngatedUpgradeBannerRedesign2024) {
    return /*#__PURE__*/_jsxs(Container, {
      className: className,
      style: Object.assign({}, style),
      children: [/*#__PURE__*/_jsx(SkeletonCircle, {
        size: 24
      }), /*#__PURE__*/_jsx(SkeletonText, {
        className: "m-left-4",
        width: "50%"
      })]
    });
  }
  const bannerStyle = Object.assign({}, style, {
    color: OBSIDIAN,
    background: OLAF,
    minHeight: '82px',
    border: `1px solid ${CALYPSO_MEDIUM}`,
    borderRadius: '5px',
    gap: '16px 0'
  });
  return /*#__PURE__*/_jsx(UIBanner, {
    style: bannerStyle,
    className: className,
    children: /*#__PURE__*/_jsxs(UIFlex, {
      className: "p-y-3",
      wrap: "wrap",
      align: "center",
      justify: "center",
      children: [/*#__PURE__*/_jsx(UIBox, {
        basis: 250,
        grow: 100,
        className: "flex-wrap align-center",
        style: {
          gap: '8px 0'
        },
        children: /*#__PURE__*/_jsxs(UIBox, {
          className: "m-right-4 align-center",
          grow: 1,
          style: {
            lineHeight: 1
          },
          children: [/*#__PURE__*/_jsx(SkeletonCircle, {
            size: 24
          }), /*#__PURE__*/_jsx(SkeletonText, {
            className: "m-left-4",
            width: "30%"
          }), /*#__PURE__*/_jsx(SkeletonText, {
            className: "m-left-4",
            width: "40%"
          })]
        })
      }), /*#__PURE__*/_jsx(UIBox, {
        basis: 110,
        children: /*#__PURE__*/_jsx(SkeletonBox, {
          width: "107px",
          height: "40px"
        })
      })]
    })
  });
};
export default LoadingBanner;